import type { ReactNode, VoidFunctionComponent } from 'react';

import ViewPathModal from '../../modals/ViewPathModal';
import IssueDetailsActionButtons from '../ActionButtons';
import IssueDetailsComments from '../Comments';
import IssueDetailsProjectTable from '../ProjectsTable';
import IssueDetailsReachabilityGate from '../Reachability/gate';
import IssueDetailsStatus from '../Status';
import IssueDetailsTabs from '../Tabs';
import type { IssueDetailsTab } from '../Tabs';

import { IssueDetailsLicensesTable } from './LicensesTable';

type IssueGenericDrawerContentProps = {
  activeTab: IssueDetailsTab;
  setActiveTab: (tab: IssueDetailsTab) => void;
  headerSlot: ReactNode;
  contentSlot: ReactNode;
};

const IssueGenericContent: VoidFunctionComponent<IssueGenericDrawerContentProps> = ({
  activeTab,
  setActiveTab,
  headerSlot,
  contentSlot,
}) => (
  <>
    {headerSlot}
    <IssueDetailsStatus />
    <IssueDetailsActionButtons />
    <IssueDetailsTabs activeTab={activeTab} onChange={setActiveTab} />
    {activeTab === 'issue' && contentSlot}
    {activeTab === 'projects' && (
      <IssueDetailsProjectTable />
    )}
    {activeTab === 'licenses' && (
      <IssueDetailsLicensesTable />
    )}
    {activeTab === 'reachability' && (
      <IssueDetailsReachabilityGate />
    )}
    {activeTab === 'comments' && (
      <IssueDetailsComments />
    )}
    {/* Note: This modal can be opened from multiple places in the drawer/details page, which is why it is rendered way up here in the component tree */}
    <ViewPathModal />
  </>
);

export default IssueGenericContent;
